import React from 'react'
import { useSelector, useDispatch } from 'react-redux'

import {
  CCloseButton,
  CSidebar,
  CSidebarBrand,
  CSidebarFooter,
  CSidebarHeader,
  CSidebarToggler,
} from '@coreui/react'

// Si tu veux utiliser une icône CoreUI ici, sinon supprime CIcon
// import CIcon from '@coreui/icons-react'

import { AppSidebarNav } from './AppSidebarNav'

// sidebar nav config
import navigation from '../_nav'
import { Link } from "react-router-dom";

const AppSidebar = () => {
  const dispatch = useDispatch()
  const unfoldable = useSelector((state) => state.sidebarUnfoldable)
  const sidebarShow = useSelector((state) => state.sidebarShow)

  return (
      <CSidebar
          className="border-end"
          colorScheme="dark"
          position="fixed"
          unfoldable={unfoldable}
          visible={sidebarShow}
          onVisibleChange={(visible) => {
            dispatch({ type: 'set', sidebarShow: visible })
          }}
      >
        <CSidebarHeader className="border-bottom">
          <CSidebarBrand to="/" className="d-flex align-items-center">
            {/* Image logo pleine */ }
            <div
                className="sidebar-logo-wrapper"
                style={ {
                  display : 'flex' ,
                  flexDirection : 'column' ,
                  alignItems : 'center' ,
                  textAlign : 'center' ,
                  maxWidth : '180px' ,
                  margin : '0 auto' ,
                } }
            >
              <Link
                  to="/"
                  className="sidebar-logo"
                  style={ {
                    display : 'flex' ,
                    alignItems : 'center' ,
                    textDecoration : 'none' ,
                  } }
              >
                <img
                    src={ process.env.PUBLIC_URL + "/assets/images/logo.png" }
                    alt="Logo"
                    style={ {
                      width : 50 ,
                      height : 50 ,
                      objectFit : "cover" ,
                      borderRadius : "50%" ,
                      border : "2px solid #fff" ,
                      backgroundColor : "#fff" ,
                      marginRight : 10 ,
                    } }
                />
                <span
                    className="sidebar-logo-text"
                    style={ {
                      fontSize : "1.3rem" ,
                      fontWeight : "bold" ,
                      color : "#ffffff" ,
                      letterSpacing : "0.5px" ,
                      textTransform : "uppercase" ,
                      whiteSpace : "normal" ,
                      wordWrap : "break-word" ,
                    } }
                >
      TheSustain
    </span>
              </Link>


            </div>

            {/* Image logo réduite pour petit sidebar */ }
            <img
                src={ process.env.PUBLIC_URL + "/assets/images/logo.png" } // chemin vers l’image dans public/coreui-assets/brand/sygnet.png
                alt="Sygnet"
                className="sidebar-brand-narrow ms-2"
                height={ 32 }
            />
          </CSidebarBrand>
          <CCloseButton
              className="d-lg-none"
              dark
              onClick={ () => dispatch ( { type : 'set' , sidebarShow : false } ) }
          />
        </CSidebarHeader>
        {/* Slogan - en dehors du Link, donc pas affecté */ }
        <p
            className="sidebar-slogan"
            style={ {
              fontSize : '0.9rem' ,
              fontStyle : 'italic' ,
              marginTop : '8px' ,
              color : '#f4f3c4' ,
              lineHeight : 1.3 ,
              textAlign : 'center' ,
              wordBreak : 'break-word' ,
              whiteSpace : 'normal' ,
            } }
        >
          Semer sur la terre pour récolter dans les cieux
        </p><hr/>
        <AppSidebarNav items={ navigation }/>

        <CSidebarFooter className="border-top d-none d-lg-flex">
          <CSidebarToggler
              onClick={ () => dispatch ( { type : 'set' , sidebarUnfoldable : ! unfoldable } ) }
          />
        </CSidebarFooter>
      </CSidebar>
  )
}

export default React.memo ( AppSidebar )
